/*
 * Event handlers for general content tasks.
 */
var ContentController = (function($) {

	var win, doc, header;

	function ready() {
		win = $(window);
		doc = $(document.body);
		header = $("header");
		doc.on('click', '.collapsible-content a.read-more', onMoreClick);
		doc.on('click', '.collapsible-content a.read-less', onLessClick);
		buildCollapsibleContent();
		selectBehavior();
		fixH2BorderTextWrap();

		fixContentIframes();
		win.on('resize', fixContentIframes);

	    // move the narrowA after the content if it is the left column
		if ($('section.content').first().prev('aside.hide-small:hidden').length > 0) {
		    $('section.content').prev('aside.hide-small:hidden').detach().insertAfter($('section.content').first());
		    $('aside.hide-small:hidden').show().css({'margin-left': 'auto', 'margin-right': 'auto', 'width': '90%'});
		}
	}

	/*
	 * Fix all iframes in the content area.
	 */
	function fixContentIframes() {
		$("section.content iframe").each(fixIframe);
	}

	/*
	 * Fix iframe to be responsive.
	 * Replace the width and height attributes and give them responsive values.
	 */
	function fixIframe() {
		var iframe = $(this),
			src = iframe.attr('src'),
			minHeight = (win.outerHeight() - header.outerHeight()) * .67;

		if (/maps\.google\.com/gi.test(src)) {
			iframe.attr('width', '100%');
			iframe.attr('height', '');
			iframe.css({
				"min-height": minHeight
			});
		}
	}

	function fixH2BorderTextWrap() {
		if (!BreakpointController.isMobile()) return;
		
		$("h2.border, h3.border").each(function () {
			var html = $(this).html();
			$(this).html("<span>" + html + "</span>");
		});
	}
	
	function selectBehavior() {
		doc.on("focus", 'select', function (e) {
			var wrapper = $(this).closest('.select');
			if (wrapper.length > 0) {
				wrapper.addClass("focus");
			}
		});
		
		doc.on("blur", 'select', function (e) {
			var wrapper = $(this).closest('.select');
			if (wrapper.length > 0) {
				wrapper.removeClass("focus");
			}
		});
	}
	
	function buildCollapsibleContent() {
		$(".collapsible-content").each(function () {
			var collapsibleContentSection = $(this);
			// If there's only 1 paragraph, don't bother with the read more/less.
			if (collapsibleContentSection.children('p').length <= 1) {
				return;
            }
            var headerTag = collapsibleContentSection.children("h2:first-of-type");
            var headerText = "";
            if (headerTag.length > 0) { headerText = " about " + headerTag.text().trim(); }
            var firstP = collapsibleContentSection.children('p:first-of-type');
            var lastP = collapsibleContentSection.children('p:last-of-type');
            var readMore = $("<a href='#' class='read-more' aria-label='Read more" + headerText + "'>More &gt;</a>");
            var readLess = $("<a href='#' class='read-less' aria-label='Read less" + headerText + "'>&lt; Less</a>");
			firstP.append(readMore);
			lastP.append(readLess);
		});
	}
	
	function onMoreClick(e) {
		e.preventDefault();
		var clicked = $(this);
		var container = clicked.closest('.collapsible-content');
		container.addClass('open');
	}
	
	function onLessClick(e) {
		e.preventDefault();
		var clicked = $(this);
		var container = clicked.closest('.collapsible-content');
		container.removeClass('open');
		
		// var isPersonnel = container.closest(".personnel").length > 0;
		// var scrollTo = container.children('p').first();
		// if (isPersonnel) {
		//	 scrollTo = scrollTo.closest('li');
		// }
		// ScrollController.scrollTo(scrollTo, true);
	}
	
	$(ready);
	
	return {
		ready: ready
	};
	
})(jQuery);